module.exports = __webpack_public_path__ + "img/icon_close_1.3e7a86cc.png";